// Service Worker Registration

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = '/service-worker.js';

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('[PWA] Service worker registered:', registration.scope);

          // Check for updates
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker) {
              installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    // New content available
                    console.log('[PWA] New content available; please refresh.');
                    // Dispatch event for the app to handle
                    window.dispatchEvent(new CustomEvent('swUpdate', { detail: registration }));
                  } else {
                    // Content cached for offline use
                    console.log('[PWA] Content cached for offline use.');
                  }
                }
              };
            }
          };
        })
        .catch((error) => {
          console.error('[PWA] Service worker registration failed:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[PWA] Service worker unregistration failed:', error);
      });
  }
}

// Check if app is installed
export function isInstalled() {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
}

// Prompt user to install
export function promptInstall() {
  return new Promise((resolve, reject) => {
    if (!window.deferredPrompt) {
      reject(new Error('Install prompt not available'));
      return;
    }

    window.deferredPrompt.prompt();
    window.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('[PWA] User accepted install prompt');
        resolve(true);
      } else {
        console.log('[PWA] User dismissed install prompt');
        resolve(false);
      }
      window.deferredPrompt = null;
    });
  });
}

// Listen for install prompt
export function listenForInstallPrompt(callback) {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.deferredPrompt = e;
    console.log('[PWA] Install prompt available');
    if (callback) callback(true);
  });

  window.addEventListener('appinstalled', () => {
    console.log('[PWA] App installed');
    window.deferredPrompt = null;
    if (callback) callback(false);
  });
}
